module.exports = __webpack_public_path__ + "img/special_whiteningessence.7331e7a5.jpg";